<template>
  <div v-show="isLimit===false" class="noLimit">
    <img src="@/assets/images/noLimit.png" alt="">
  </div>
</template>

<script>
export default {
  name: "emptyPage",
  props:['isLimit'],
  watch:{
    isLimit(val){
      if(val===false){
        this.$notify({
          message:'您权限不足，请联系管理员开通',
          duration:3200
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.noLimit{
  width: 100vw;
  height: 100vh;
  background-color: #FFFFFF;
  img{
    width: 300px;
    position: fixed;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
